import { ExclamationCircleFilled, InfoCircleFilled } from "@ant-design/icons";

/** Лентата над формата — фактурата за депозит, свободната фактура, „Депозити",
 *  купувачът на фискалната фактура и прегледът на документ от ФУ. */
export function NoticeBanner({ tone, text }: { tone: "info" | "warn"; text: string }) {
  const toneClass =
    tone === "warn"
      ? "bg-[var(--color-warn-tint)] text-[var(--color-warn-ink)]"
      : "bg-[var(--color-info-tint)] text-[var(--color-info-deep)]";
  return (
    <div
      role={tone === "warn" ? "alert" : "status"}
      className={`flex items-start gap-2 rounded-[10px] px-3 py-2.5 text-[13px] font-medium leading-[1.4] ${toneClass}`}
    >
      {tone === "warn" ? (
        <ExclamationCircleFilled className="mt-[2px]" />
      ) : (
        <InfoCircleFilled className="mt-[2px]" />
      )}
      <span>{text}</span>
    </div>
  );
}
